import {useQuery} from '@tanstack/react-query';
import {fetchCancellationReasons} from '../endpoints/api';
import {CancellationReason} from '../types/membership';

/**
 * Hook to fetch cancellation reasons from the API.
 * Reasons are static, so we cache them indefinitely.
 */
export function useCancellationReasons(enabled: boolean = true) {
  return useQuery({
    queryKey: ['cancellationReasons'],
    queryFn: async (): Promise<CancellationReason[]> => {
      const response: any = await fetchCancellationReasons();
      return Array.isArray(response.data) ? response.data : response.data.data;
    },
    enabled,
    staleTime: Infinity,
    cacheTime: Infinity,
  });
}
